import { isoZ, z } from 'my-zod'

export const additionalCustomerOrderQuestionTypeOptions = [
  'checkboxRequired',
  'checkboxOptional',
  'textRequired',
  'textOptional'
] as const
export const AdditionalCustomerOrderQuestionType = z.enum(additionalCustomerOrderQuestionTypeOptions)
export type AdditionalCustomerOrderQuestionType = z.infer<typeof AdditionalCustomerOrderQuestionType>

export const additionalCustomerOrderQuestionTypeLabels: { [key in AdditionalCustomerOrderQuestionType]: string } = {
  checkboxOptional: 'Checkbox (Optional)',
  checkboxRequired: 'Checkbox (Required)',
  textRequired: 'Text (Required)',
  textOptional: 'Text (Optional)'
}

export const additionalCustomerOrderQuestionModel = z.object({
  id: z.number(),
  outfitterId: z.number(),
  type: z.enum(additionalCustomerOrderQuestionTypeOptions),
  prompt: z.string().max(256),
  description: z.string().max(1500),
  productIds: z.string().array(),
  orderOfAppearance: z.number(),
  createdDate: isoZ.instant(),
  lastModifiedDate: isoZ.instant(),
  deletedDate: isoZ.instant().nullable()
})

export type additionalCustomerOrderQuestionModel = z.infer<typeof additionalCustomerOrderQuestionModel>
